import React, {Component}   from "react";
import {View}               from "react-native";
import {Provider}           from "react-redux";
import {createStore}        from "redux";
import Screen               from "./src/components/screens/Screen";
import rootReducer          from "./src/reducers/RootReducer";
import styles               from "./src/styles/Styles";

export default class App extends Component {
    render() {
        let store = createStore(rootReducer);

        return (
            <Provider store={store}>
                <View style={styles.container}>
                    <Screen />
                </View>
            </Provider>
        );
    }
}